import { formatNumberOrDash } from '@/utils/numberFormat';
import { useTranslation } from 'react-i18next';
import { SURFACE } from '../constants';
import { HarvestPlacesRegionRow } from '../model';
import { cn } from '@/lib/utils';

/** Xaritada hudud ustiga kursor kelganda chiqadigan karta — faqat allaqachon
 *  yuklangan `regions[]` qatoridan o'qiydi, qo'shimcha so'rov qilmaydi. */
export const RegionTooltip = ({
  region,
}: {
  region: HarvestPlacesRegionRow;
}) => {
  const { t } = useTranslation();

  const rows = [
    {
      label: `${t('places_count')}:`,
      value: formatNumberOrDash(region.places_count),
    },
    {
      label: `${t('clusters_count')}:`,
      value: formatNumberOrDash(region.clusters_count),
    },
    {
      label: `${t('count_of_cooperations')}:`,
      value: formatNumberOrDash(region.cooperations_count),
    },
    {
      label: `${t('delivered_tons')}:`,
      value: formatNumberOrDash(region.physical_total_net, ` ${t('ton')}`),
    },
  ];

  return (
    <div
      className={cn(
        'flex min-w-[220px] flex-col gap-2 rounded-[8px] border border-border px-4 py-3 shadow-lg',
        SURFACE,
      )}
    >
      <span className="text-sm font-semibold text-foreground">
        {region.name_uz}
      </span>
      {rows.map((row) => (
        <div key={row.label} className="flex justify-between gap-4">
          <span className="text-xs font-normal text-foreground opacity-50">
            {row.label}
          </span>
          <span className="text-xs font-medium text-foreground">
            {row.value}
          </span>
        </div>
      ))}
    </div>
  );
};
